import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MetricIconService } from 'src/app/services/metrics/metrics-icons.service';
import { QuestionOptionsConstantService } from 'src/app/components/create-custom-question/options-constant.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.pug',
  styleUrls: ['./question.component.scss'],
  standalone: false
})
export class QuestionComponent implements OnInit {
  @Input() question: any;
  @Input() canManage = false;
  @Input() type = 'exit';
  @Input() questionClass = '';
  @Output() hide:EventEmitter<any> = new EventEmitter();
  @Output() delete:EventEmitter<any> = new EventEmitter();
  @Output() edit:EventEmitter<any> = new EventEmitter();
  @Output() menu:EventEmitter<any> = new EventEmitter();
  showAnswers = false;
  options_map = QuestionOptionsConstantService.questionTypes;
  response_type = "";
  ownerOrAdmin = false;
  dropdownOptions: any[] = [];
  ENT_10363_PULSE_RELAUNCH = false;

  constructor(private metricIconService: MetricIconService,
              private permissionsService: PermissionsService,) { }

  ngOnInit(): void {
    this.response_type = this.options_map[this.question.response_type.toUpperCase()].label;
    this.ownerOrAdmin = this.permissionsService.data['role'] == 'admin' || this.permissionsService.data['role'] == 'owner';
    this.ENT_10363_PULSE_RELAUNCH = this.permissionsService.isFeatureActivated('ENT-10363-pulse-relaunch');
    this.setDropdownOptions();
  }

  getMetricIcon(metric){
    return this.metricIconService.getMetricIcon(metric);
  }

  setDropdownOptions(): void {
    if (this.question['is_custom'] && this.question['is_locked']) {
      this.dropdownOptions.push({'key': 'hide', 'value': $localize`Hide question`})
    }
    if (this.question['is_custom'] && !this.question['is_locked']) {
      this.dropdownOptions.push({'key': 'delete', 'value': $localize`Delete question`})
      this.dropdownOptions.push({'key': 'edit', 'value': $localize`Edit question`})
    }
  }

  kebabMenuChange(event) {
    if (event['key'] === 'hide') {
      this.hide.emit();
    } else if (event['key'] === 'delete') {
      this.delete.emit();
    } else if (event['key'] === 'edit') {
      this.edit.emit();
    }
  }
}
